var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5573 80.291L65.1284 60.8568V30.1229L31.5573 49.5584V80.291Z",
    fill: "#C9974B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4304 34.4568V33.3887L31.5591 49.5588V50.6256L45.8593 53.8911L79.4304 34.4568Z",
    fill: "#BF8937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93758 36.3964L31.5613 49.5585V80.2911L8.93758 67.2035V36.3964Z",
    fill: "#AB7835"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2476 64.5377L29.2727 69.808V75.8645L20.2476 70.6078V64.5377Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2398 43.6554L11.2574 48.3306L13.411 49.5587L13.3947 44.8835L14.4708 45.4975L12.3051 40.8955L10.1624 43.0413L11.2398 43.6554Z",
    fill: "#471D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0958 41.7996L21.3579 43.6295L21.4255 51.0687L18.0958 49.0828V41.7996Z",
    fill: "#C2BFB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1369 66.0515L21.506 66.2738V70.3431L21.1369 70.1208V66.0515Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9005 66.4973L22.2695 66.7196V70.7876L21.9005 70.5652V66.4973Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6649 66.9426L23.0353 67.1649V71.2342L22.6649 71.0119V66.9426Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4264 67.3873L23.7968 67.6096V71.6789L23.4264 71.4566V67.3873Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1913 67.8331L24.5603 68.0554V72.1247L24.1913 71.9024V67.8331Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9548 68.2767L25.3239 68.499V72.5683L24.9548 72.346V68.2767Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7171 68.723L26.0875 68.9453V73.0133L25.7171 72.791V68.723Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4798 69.1677L26.8489 69.39V73.4593L26.4798 73.237V69.1677Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2456 69.6124L27.6146 69.8347V73.904L27.2456 73.6817V69.6124Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0078 70.0587L28.3782 70.281V74.3503L28.0078 74.128V70.0587Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571842 27.0156L8.93589 37.4641L42.5071 18.0298L0.571842 25.9488V27.0156Z",
    fill: "#AB7835"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.572086 25.9482L8.93613 36.3967L42.5073 16.961L34.1432 6.51263L0.572086 25.9482Z",
    fill: "#FFDC91"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4304 33.3889L65.1303 30.1235L31.5591 49.5591L45.8593 52.8245L79.4304 33.3889Z",
    fill: "#D6AC54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5039 16.9609L65.1276 30.1231L31.5564 49.5587L8.93271 36.3965L42.5039 16.9609Z",
    fill: "#EBC26C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6276 36.3979L24.3217 43.7855L31.5543 47.9877L42.5045 41.6574L49.1692 37.7941L62.4312 30.1218L42.5045 18.532L11.6276 36.3979Z",
    fill: "#AB7835"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6296 36.3979L24.3237 43.7855L31.5563 47.9877L42.5065 41.6574V18.532L11.6296 36.3979Z",
    fill: "#C9974B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3229 40.966V43.7855L31.5554 47.9876L42.5057 41.6573L49.1704 37.794L42.5057 33.9308L39.5045 32.1821L24.3229 40.966Z",
    fill: "#B39876"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8579 52.8239V53.8907L31.5577 50.6253V49.5585L45.8579 52.8239Z",
    fill: "#AB7835"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5561 43.1778L49.7336 34.3913V23.9266L34.5561 32.7131V43.1778Z",
    fill: "#C9C9C9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5561 32.7136L49.7336 23.927L39.5067 17.9763L24.3278 26.7628L34.5561 32.7136Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.327 26.7634L34.5553 32.7142V43.1789L24.327 37.262V26.7634Z",
    fill: "#ABABAB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.34 14.7459L48.3224 3.94237L53.2852 1.07812L56.9271 3.23612L53.3041 11.8817L55.7848 10.4503L59.4268 12.6083L54.4762 23.2668L50.8356 21.1088L45.8593 16.1787L48.34 14.7459Z",
    fill: "#125200"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.982 16.9052L51.9644 6.10027L56.9271 3.23602L56.9447 14.0396L59.4268 12.6082L54.4762 23.2667L49.5013 18.3366L51.982 16.9052Z",
    fill: "#11FF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7009 9.00477L15.7266 20.4061L20.9746 23.4073L24.8166 21.1273L24.8153 10.5609L23.5743 13.5078L27.4149 11.2265L22.148 0L18.306 2.27999L13.0756 7.50284L15.7009 9.00477Z",
    fill: "#94000A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6998 9.00145L15.7255 20.4028L20.9735 23.404L20.9478 12.0039L23.5731 13.5045L18.3048 2.27667L13.0744 7.50089L15.6998 9.00145Z",
    fill: "#F91F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndMission);
export default __webpack_public_path__ + "static/media/end_mission.969f28db1ffcc3089a51fb1ab4e8125b.svg";
export { ForwardRef as ReactComponent };